import { h } from 'preact';

const Chevron = () => (
	<svg
		width={20}
		height={25}
		viewBox="0 0 20 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.468 15.508l-.466.428-.466-.428L3.173 9.67l-.554-.508.554-.508.572-.525.466-.428.467.428 5.324 4.885 5.324-4.885.466-.428.467.428.572.525.554.508-.554.508-6.363 5.838z"
			fill="#00394D"
			stroke="#00394D"
			strokeWidth={1.3787}
		/>
	</svg>
);

export default Chevron;
